import React from 'react';
import { useWatch } from 'react-hook-form';

import ProductPrice from 'components/ProductPrice';
import { Button } from 'ui-components/v2/Button';
import { getSubtotal } from 'utils/getSubtotal';
import { HookFormProps, PDPProps } from 'pages/pdp/interface';
import { DualCheckoutButtons } from 'pages/pdp/DualCheckoutButtons';
import { PurchaseFormFieldNames as FIELD_NAMES } from 'constants/form';

export const ATC = ({
  id,
  control,
  product,
  loading,
  onSubmit,
  setValue,
  handleSubmit,
  submitError,
  shouldShowDualButtons,
}: Pick<PDPProps, 'product'> &
  HookFormProps & { id: string; shouldShowDualButtons: boolean }) => {
  const addons = useWatch({ control, name: FIELD_NAMES.addons });
  const noStock = useWatch({ control, name: FIELD_NAMES.noStock });
  const dateInvalid = useWatch({ control, name: FIELD_NAMES.dateInvalid });

  const subtotal = getSubtotal(addons, product.price, product.price).toFixed(2);
  const salesSubtotal = product.sales_price
    ? getSubtotal(addons, product.price, product.sales_price).toFixed(2)
    : null;

  const isBottomBar = id.includes('sticky');
  const isButtonDisabled =
    loading || !product.purchasable || noStock || dateInvalid;

  return (
    <div className="flex flex-col gap-2">
      {shouldShowDualButtons ? (
        <DualCheckoutButtons
          isBottomBar={isBottomBar}
          product={product}
          subtotal={subtotal}
          salesSubtotal={salesSubtotal}
          disabled={isButtonDisabled}
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          setValue={setValue}
        />
      ) : (
        <Button
          id={id}
          fullWidth
          color="primary"
          variant="contained"
          className={`tracking-add-to-cart ${isBottomBar ? 'sm:max-md:portrait:!h-[60px]' : 'max-sm:!h-14 max-sm:!text-base'}`}
          disabled={isButtonDisabled}
          onClick={handleSubmit(onSubmit)}
          tabIndex={isBottomBar ? -1 : undefined}
        >
          {noStock || !product.purchasable ? (
            'Sold Out!'
          ) : (
            <>
              <span className="mr-1">Add To Cart -</span>
              <ProductPrice price={subtotal} salesPrice={salesSubtotal} />
            </>
          )}
        </Button>
      )}
      {submitError ? (
        <p
          role="alert"
          className={`m-0 text-sm text-red-700 ${isBottomBar ? 'text-right' : 'text-center'}`}
        >
          {submitError}
        </p>
      ) : null}
    </div>
  );
};
